import useWindowSize, { Size } from "hooks/useWindowSize";
import React from "react";
import Slider from "react-slick";

import Patner001 from "assets/images/Patners/Patner01.svg";
import Patner002 from "assets/images/Patners/Patner02.svg";
// import Patner003 from "assets/images/Patners/Patner03.png";
import Patner003 from "assets/images/Patners/Patner03.svg";
import Patner004 from "assets/images/Patners/Patner04.png";
// import Patner004 from "assets/images/Patners/Patner04.svg";
import Patner005 from "assets/images/Patners/Patner05.png";
// import Patner005 from "assets/images/Patners/Patner05.svg";
import Patner006 from "assets/images/Patners/Patner06.svg";
import Patner007 from "assets/images/Patners/Patner07.svg";
import Patner008 from "assets/images/Patners/Patner08.svg";
// import Patner008 from "assets/images/Patners/Patner08.jpg";
import Patner009 from "assets/images/Patners/Patner09.svg";
import Patner010 from "assets/images/Patners/Patner10.png";
// import Patner010 from "assets/images/Patners/Patner10.svg";
// import Patner011 from "assets/images/Patners/Patner11.jpg";
import Patner011 from "assets/images/Patners/Patner11.svg";
// import Patner012 from "assets/images/Patners/Patner12.png";
import Patner012 from "assets/images/Patners/Patner12.svg";
import Patner013 from "assets/images/Patners/Patner13.svg";
import Patner014 from "assets/images/Patners/Patner14.svg";
import Marquee from "react-fast-marquee";

import * as S from "./style";

function Patners() {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    pauseOnHover: false,
    arrows: false,
  };

  return (
    <S.Container id="partners">
      <S.Content>
        <S.TextTitle>| PARTNERS</S.TextTitle>
        <S.PatnersList>
          <S.PatnersImg id="patnersList">
            <img src={Patner001} alt="img partner" />
            <img src={Patner002} alt="img partner" />
            <img src={Patner003} alt="img partner" />
            <img src={Patner004} alt="img partner" />
            <img src={Patner005} alt="img partner" />
            <img src={Patner006} alt="img partner" />
            <img src={Patner007} alt="img partner" />
            <img src={Patner008} alt="img partner" />
            <img src={Patner009} alt="img partner" />
            <img src={Patner010} alt="img partner" />
            <img src={Patner011} alt="img partner" />
            <img src={Patner012} alt="img partner" />
            <img src={Patner013} alt="img partner" />
            <img src={Patner014} alt="img partner" />
          </S.PatnersImg>
        </S.PatnersList>
        <S.SliderBox>
          <Marquee gradient={false} speed={30}>
            <img src={Patner001} alt="img partner" />
            <img src={Patner002} alt="img partner" />
            <img src={Patner003} alt="img partner" />
            <img src={Patner004} alt="img partner" />
            <img src={Patner005} alt="img partner" />
            <img src={Patner006} alt="img partner" />
            <img src={Patner007} alt="img partner" />
            <img src={Patner008} alt="img partner" />
            <img src={Patner009} alt="img partner" />
            <img src={Patner010} alt="img partner" />
            <img src={Patner011} alt="img partner" />
            <img src={Patner012} alt="img partner" />
            <img src={Patner013} alt="img partner" />
            <img src={Patner014} alt="img partner" />
          </Marquee>
        </S.SliderBox>
        {/* <S.SliderBox>
          <Slider {...settings}>
            <img src={Patner001} alt="img partner" />
            <img src={Patner002} alt="img partner" />
            <img src={Patner003} alt="img partner" />
            <img src={Patner004} alt="img partner" />
            <img src={Patner005} alt="img partner" />
            <img src={Patner006} alt="img partner" />
            <img src={Patner007} alt="img partner" />
            <img src={Patner008} alt="img partner" />
            <img src={Patner009} alt="img partner" />
            <img src={Patner010} alt="img partner" />
            <img src={Patner011} alt="img partner" />
            <img src={Patner012} alt="img partner" />
            <img src={Patner013} alt="img partner" />
            <img src={Patner014} alt="img partner" />
          </Slider>
        </S.SliderBox> */}
      </S.Content>
    </S.Container>
  );
}

export default Patners;
